import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './helpSection.module.css';

export const mapStateToProps = ({ language }) => ({
  helpPillUrl:
    language['returns.landing.help_url'] || language['returns.validate.return_policy_link'] || '',
  helpPillText: language['returns.landing.help_text'] || 'NEED HELP',
});

const HelpSection = ({ helpPillUrl, helpPillText }) => (
  <div className={`returns-help-button ${s.returns_help_button || ''}`}>
    <a
      className={`returns-help-link ${s.returns_help_url || ''}`}
      href={helpPillUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/r2/img/help_outline.svg"
        className={`returns-help-icon ${s.returns_help_icon || ''}`}
        alt="Help icon"
      />
      <div className={`returns-help-text ${s.returns_help_text || ''}`}>{helpPillText}</div>
    </a>
  </div>
);

HelpSection.propTypes = {
  helpPillUrl: PropTypes.string.isRequired,
  helpPillText: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(HelpSection);
